import React, { useEffect, useState } from "react";
import { Text, Stack } from "office-ui-fabric-react";
import { FormikValues } from "formik";
import { useTranslation } from "react-i18next";
import { getOrderTypes } from "../../../connectors/orderTypes/connectors/index";
import {
  headerS,
  container,
  orderTypeContainer,
  textS,
} from "./vehicleOrderTypesCheckboxes.styles";
import NewFormCheckbox from "../../common/layout/form/NewFormCheckbox";
import { translateOrderTypeItemName } from "../../common/enums/orderTypes.enum";

const VehicleOrderTypesCheckboxes: React.SFC<{ values: FormikValues }> = ({
  values,
}) => {
  const { t } = useTranslation("admin");
  const [OrderTypes, setOrderTypes] = useState([]);

  useEffect(() => {
    get();
  }, []);

  const get = async () => {
    const res = await getOrderTypes();
    setOrderTypes(res.data.data);
  };

  return (
    <Stack verticalAlign="center">
      <Text styles={headerS}>{t("vehicles.supportedOrderTypes")}</Text>
      <Stack horizontal wrap horizontalAlign="space-between">
        {OrderTypes.map((orderType: any) => {
          const typeNameMap: any = {
            "Pojazd": t("orders.typeValues.vehicle"),
            "Tonaż": t("orders.typeValues.tonnage"),
            "Kontener": t("orders.typeValues.container"),
          };
          const displayName = typeNameMap[orderType.name] !== undefined ? typeNameMap[orderType.name] : orderType.name;
          return (
            <div key={orderType.id} className={container}>
              <Text styles={textS}>{displayName}</Text>
              {orderType.items.map((item: any) => {
                return (
                  <div className={orderTypeContainer} key={item.id}>
                    <NewFormCheckbox name={item.id} label={translateOrderTypeItemName(item.name, t)} />
                    {/* <Field
                          name={item.id}
                          label={item.name}
                          component={FormCheckbox}
                          checked={values[item.id]}
                        /> */}
                  </div>
                );
              })}
            </div>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default VehicleOrderTypesCheckboxes;